class CustomPopup extends HTMLElement {
  connectedCallback() {
    // Wait for a microtask to ensure the element is fully in the DOM
    Promise.resolve().then(() => this.init());
  }

  init() {
    this.closeButton = this.querySelector(".m-popup-section__close");
    this.overlay = this.querySelector(".m-popup-section__overlay");
    this.container = this.querySelector(".m-popup-section__container");
    this.formContainer = this.querySelector(".m-popup-section__form-container");
    this.thankYouContainer = this.querySelector(".m-popup-section__thank-you");
    this.delayTimeout = null;

    // Bind event handlers
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
    this.handleContainerClick = this.handleContainerClick.bind(this);
    this.handleEscapeKey = this.handleEscapeKey.bind(this);

    // Add event listeners
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.handleCloseClick);
    }

    if (this.overlay) {
      this.overlay.addEventListener("click", this.handleOverlayClick);
    }

    if (this.container) {
      this.container.addEventListener("click", this.handleContainerClick);
    }

    document.addEventListener("keydown", this.handleEscapeKey);

    // Check if form was submitted successfully
    const formSubmitted = window.location.search.includes('customer_posted=true');

    // Check sessionStorage to see if user has already closed this popup
    const popupClosedKey = `popupClosed_${this.dataset.sectionId}`;
    const delaySeconds = parseInt(this.dataset.delay || "0", 10);
    const shouldRespectDelay = Number.isFinite(delaySeconds) && delaySeconds > 0;

    const showPopup = () => {
      this.classList.add("is-visible");
      this.delayTimeout = null;
    };

    const scheduleShow = () => {
      if (shouldRespectDelay) {
        this.delayTimeout = window.setTimeout(showPopup, delaySeconds * 1000);
      } else {
        showPopup();
      }
    };

    // If form was submitted, show the thank you message and the popup
    if (formSubmitted && this.formContainer && this.thankYouContainer) {
      this.formContainer.style.display = 'none';
      this.thankYouContainer.style.display = 'block';
      showPopup();
      // Don't store in sessionStorage so it shows again next time
    } 
    // Otherwise, if not forcibly visible and not closed yet, show the regular popup
    else if (!this.classList.contains("is-visible") && !sessionStorage.getItem(popupClosedKey)) {
      scheduleShow();
    }
  }

  handleCloseClick(e) {
    e.preventDefault();
    this.close();
  }

  handleOverlayClick(e) {
    if (e.target === this.overlay) {
      e.preventDefault();
      e.stopPropagation();
      this.close();
    }
  }

  handleContainerClick(e) {
    // Prevent click inside container from closing
    e.stopPropagation();
  }

  handleEscapeKey(e) {
    if (e.key === "Escape" && this.classList.contains("is-visible")) {
      this.close();
    }
  }

  close() {
    if (this.delayTimeout) {
      window.clearTimeout(this.delayTimeout);
      this.delayTimeout = null;
    }
    // Remove the visible class
    this.classList.remove("is-visible");
    
    // Only store in sessionStorage if not showing thank you message
    const formSubmitted = window.location.search.includes('customer_posted=true');
    if (!formSubmitted) {
      sessionStorage.setItem(`popupClosed_${this.dataset.sectionId}`, "true");
    }
  }

  disconnectedCallback() {
    if (this.delayTimeout) {
      window.clearTimeout(this.delayTimeout);
      this.delayTimeout = null;
    }
    // Clean up event listeners
    if (this.closeButton) {
      this.closeButton.removeEventListener("click", this.handleCloseClick);
    }

    if (this.overlay) {
      this.overlay.removeEventListener("click", this.handleOverlayClick);
    }

    if (this.container) {
      this.container.removeEventListener("click", this.handleContainerClick);
    }

    document.removeEventListener("keydown", this.handleEscapeKey);
  }
}

// Register the custom element
customElements.define("custom-popup", CustomPopup);
